import React, {useEffect, useState} from "react";
import {cmsService} from "../../utils/axios";
import MetaTagsManipulator from "../../utils/MetaTagsManipulator";
import FaqSidebar from "./FaqSidebar";
import FaqCategorySection from "./FaqCategorySection";
import ExpertHelp from "../HomePage/ExpertHelp";
import HomeNewsletter from "../HomePage/HomeNewsletter";

function FaqPage() {

    const [mainPage, setMainPage] = useState({
        Title: null,
        Content: null
    });

    const [faqSections, setFaqSections] = useState([]);

    function buildFaqSections(faqPages, parentId, level) {
        let pagesOnLevel = faqPages.filter(page => page.ParentID === parentId).sort((page1, page2) => page1.Sort - page2.Sort);
        let pages = [];
        level = level + 1;

        if (pagesOnLevel.length > 0) {

            let children = [];
            for (let page of pagesOnLevel) {
                children = buildFaqSections(faqPages, page.ID, level);

                pages.push({
                    id: page.ID,
                    level: level,
                    title: page.Title,
                    children: children,
                    faqElements: page.Questions
                });
            }
        }
        return pages;
    }

    useEffect(() => {
        cmsService("/FAQPage?add_fields=Questions,BackgroundURL&relationdepth=0").then(response => {
            let allFaqPages = response.data.items;
            let mainPageData = allFaqPages.filter(page => page.ParentID === 0)[0];

            if (mainPageData !== undefined) {
                setMainPage(mainPageData);

                MetaTagsManipulator.setTitle(mainPageData.Title);
                MetaTagsManipulator.setDescription(mainPageData.MetaDescription);
            }

            let faqSections = buildFaqSections(allFaqPages, mainPageData.ID, 0);
            setFaqSections(faqSections);

        });
    }, []);

    return (
        <div id="content">
            <div className="blog2-breadcrumb-bar">
                <div className="blog2-breadcrumb-bar-inner">
                    <span>go-auto.pl</span>
                    <span className="blog2-breadcrumb-sep">›</span>
                    <span>Pytania i odpowiedzi</span>
                </div>
            </div>

            <div className="blog2-section">
                <div className="blog2-page-wrapper">
                    <h1 className="blog2-page-title" id="faq-top">{mainPage.Title || "Pytania i odpowiedzi"}</h1>

                    <div className="blog2-container">
                        <FaqSidebar sections={faqSections}/>

                        <div className="faq2-main">
                            {faqSections.map(section => (
                                <FaqCategorySection key={section.id} section={section}/>
                            ))}
                        </div>
                    </div>
                </div>
            </div>

            <ExpertHelp/>
            <HomeNewsletter/>
        </div>
    );

}

export default FaqPage
